import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import config from '@/config'
import "./bootstrap-3.4.1-dist/css/bootstrap.css";
// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.prototype.$EventBus = new Vue()
Vue.use(ViewUI);
import Vue2OrgTree from 'vue2-org-tree'
Vue.use(Vue2OrgTree);
//引入视频插件
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import "/src/assets/css/org-tree.less";
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)
Vue.use(require('vue-wechat-title'))
//引入ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
//复制插件
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard
Vue.prototype.$config = config
// 本地开发时注释掉 goeasy 相关代码
import '@/libs/goeasy.min.js';
// goeasy
Vue.prototype.goeasy = window.GoEasy.getInstance({
	host: "hangzhou.goeasy.io",
	appkey: "BC-903981a80c444a9ca709b5a7c8458ebf",
	modules: ['pubsub']
});
// Vue.prototype.goeasy = GoEasy.getInstance({
// 	host: "hangzhou.goeasy.io", //若是新加坡区域：singapore.goeasy.io
// 	appkey: "BC-903981a80c444a9ca709b5a7c8458ebf",
// 	modules: ['pubsub'] //根据需要，传入'pubsub'或'im'，或数组方式同时传入
// });

Vue.prototype.goeasy.connect({
	onSuccess: function() { //连接成功
		console.log("GoEasy connect successfully.") //连接成功
	},
	onFailed: function(error) { //连接失败
		console.log("Failed to connect GoEasy, code:" + error.code + ",error:" + error.content);
	},
	onProgress: function(attempts) { //连接或自动重连中
		console.log("GoEasy is connecting", attempts);
	}
});

Vue.config.productionTip = false

Date.prototype.formatTime = function() {
	var s = '';
	var mouth = (this.getMonth() + 1) >= 10 ? (this.getMonth() + 1) : ('0' + (this.getMonth() + 1));
	var day = this.getDate() >= 10 ? this.getDate() : ('0' + this.getDate());
	s += this.getFullYear() + '-'; // 获取年份。
	s += mouth + "-"; // 获取月份。
	s += day; // 获取日。
	return (s); // 返回日期。
};

Date.prototype.format = function(format) {
	var o = {
		"M+": this.getMonth() + 1, //month 
		"d+": this.getDate(), //day 
		"h+": this.getHours(), //hour 
		"m+": this.getMinutes(), //minute 
		"s+": this.getSeconds(), //second 
		"q+": Math.floor((this.getMonth() + 3) / 3), //quarter 
		"S": this.getMilliseconds() //millisecond 
	}

	if (/(y+)/.test(format)) {
		format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	}

	for (var k in o) {
		if (new RegExp("(" + k + ")").test(format)) {
			format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k])
				.length));
		}
	}
	return format;
}

// 防抖函数
Vue.prototype.pre = null;
Vue.prototype.throttle = function(fn, delay) {
	const that = this
	that.pre = that.pre || 0;
	(() => {
		var args = arguments;
		var now = Date.now();
		if (now - that.pre >= delay) {
			fn.apply(that, args)
			that.pre = Date.now()
		}
	})()
}
Vue.prototype.findBeforeArr = function(arr, key, value) {
	let ret = {}
	let length = arr.length;
	arr.forEach(function(row, index) {
		if (row[key] == value) {
			if (index == 0) {
				ret = false;
			} else {
				ret = arr[index - 1]
			}
		}
	})
	if (ret == {}) {
		return false;
	}
	return ret;
}
Vue.prototype.findNextArr = function(arr, key, value) {
	let ret = {}
	let length = arr.length;
	arr.forEach(function(row, index) {
		if (row[key] == value) {
			if (index == length - 1) {
				ret = false;
			} else {
				ret = arr[index + 1]
			}
		}
	})
	if (ret == {}) {
		return false;
	}
	return ret;
}
new Vue({
	router,
	render: h => h(App),
	store
}).$mount('#app')